import React from 'react'
import { App as AntdApp, ConfigProvider } from 'antd'
import koKR from 'antd/locale/ko_KR'
import dayjs from 'dayjs'
import 'dayjs/locale/ko'
import { TenantConfigProvider } from './contexts/TenantConfigContext'
import { AuthProvider } from './contexts/AuthContext'
import AppRouter from './routes/AppRouter'
import SessionExpiredModal from './features/auth/SessionExpiredModal'
import { getBrandTheme } from './config/brands'

dayjs.locale('ko')

// 빌드한 브랜드의 메인 색·바탕색(src/config/brands.json의 theme)
const brandTheme = getBrandTheme()

const App: React.FC = () => (
  <ConfigProvider
    locale={koKR}
    theme={{
      token: {
        colorPrimary: brandTheme.primary,
        colorBgLayout: brandTheme.background,
        fontFamily: "'Noto Sans KR', 'Apple SD Gothic Neo', sans-serif",
        borderRadius: 6,
      },
    }}
  >
    <AntdApp>
      {/* TenantConfigProvider가 가장 바깥 — /api/config 응답 전까지 로딩 표시 */}
      <TenantConfigProvider>
        <AuthProvider>
          <AppRouter />
          {/* 라우트와 무관하게 한 번만 마운트 — /recorder/:gameInfoId는 MainLayout 바깥의 전체화면
              라우트라 레이아웃 안에 두면 그 화면에서는 뜨지 않는다(세션 만료 시 재인증 모달, 2026-09-22). */}
          <SessionExpiredModal />
        </AuthProvider>
      </TenantConfigProvider>
    </AntdApp>
  </ConfigProvider>
)

export default App
